import _regenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { callPhone as _callPhone } from '@/api/admissionCounseling/customerDrawerCom';
export default {
  name: 'PhoneCallCom',
  props: {
    cId: {
      type: Number,
      required: true
    },
    contactPhone: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      rules: {
        selected: [{
          required: true,
          trigger: 'blur',
          message: '请选择手机号进行外呼'
        }]
      },
      phone: {
        isExist: false,
        visible: false,
        selected: '',
        loading: false
      }
    };
  },
  methods: {
    handlePhoneDialogVisible: function handlePhoneDialogVisible() {
      var phone = this.phone;
      !phone.isExist && (phone.isExist = true);
      phone.visible = !phone.visible;
    },
    handleCall: function handleCall() {
      var $refs = this.$refs,
        callPhone = this.callPhone;
      $refs['phone'].validate(function (isPass) {
        if (isPass) {
          callPhone();
        } else {
          return false;
        }
      });
    },
    handleLoading: function handleLoading() {
      var phone = this.phone;
      phone.loading = !phone.loading;
    },
    callPhone: function callPhone() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var handleLoading, phone, cId, handlePhoneDialogVisible;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              handleLoading = _this.handleLoading, phone = _this.phone, cId = _this.cId, handlePhoneDialogVisible = _this.handlePhoneDialogVisible;
              handleLoading();
              // $store.dispatch('doCall', {
              //   cId,
              //   phone: phone.selected,
              // });
              _context.n = 1;
              return _callPhone({
                id: cId,
                phone: phone.selected
              }).finally(function () {
                handleLoading();
                handlePhoneDialogVisible();
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  }
};